(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-gift-box-bundler"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-box-builder')) {
    class GiftBoxBuilder extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this._ready) return;
        const cfgEl = this.querySelector('[data-gb-config]');
        if (!cfgEl) return;
        this._ready = true;

        this.cfg = JSON.parse(cfgEl.textContent);
        this.boxEls = [...this.querySelectorAll('[data-gb-box]')];
        this.itemEls = [...this.querySelectorAll('[data-gb-item]')];
        this.slotsEl = this.querySelector('[data-gb-slots]');
        this.previewImg = this.querySelector('[data-gb-preview-img]');
        this.previewPh = this.querySelector('[data-gb-preview-ph]');
        this.previewName = this.querySelector('[data-gb-preview-name]');
        this.msgEl = this.querySelector('[data-gb-message]');
        this.countEl = this.querySelector('[data-gb-count]');
        this.receiptEl = this.querySelector('[data-gb-receipt]');
        this.discountEl = this.querySelector('[data-gb-discount]');
        this.progressText = this.querySelector('[data-gb-progress-text]');
        this.tagEl = this.querySelector('[data-gb-tag]');
        this.barEl = this.querySelector('[data-gb-bar]');
        this.totalEl = this.querySelector('[data-gb-total]');
        this.wasEl = this.querySelector('[data-gb-was]');
        this.noteEl = this.querySelector('[data-gb-note]');

        this.bogoEl = this.querySelector('[data-gb-bogo]');

        this.feedbackEl = this.querySelector('[data-gb-feedback]');
        this.submitBtn = this.querySelector('[data-gb-submit]');
        this.submitLabel = this.querySelector('[data-gb-submit-label]');
        this.defaultLabel = this.submitLabel ? this.submitLabel.textContent : '';

        try {
          this.nf = new Intl.NumberFormat(this.cfg.locale, { style: 'currency', currency: this.cfg.currency });
        } catch (e) {
          this.nf = null;
        }

        this.tiers = this.cfg.discountEnabled
          ? this.cfg.tiers
              .filter((t) => t.items > 0 && t.percent > 0 && t.items <= this.cfg.max)
              .sort((a, b) => a.items - b.items)
          : [];

        this.state = { box: this.boxEls.find((b) => !b.disabled) || null, items: [] };

        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-gb-variant]')) this.onVariant(e.target);
        });
        if (this.msgEl) {
          this.msgEl.addEventListener('input', () => {
            if (this.countEl) this.countEl.textContent = this.msgEl.value.length + '/' + this.msgEl.maxLength;
          });
        }

        this.itemEls.forEach((el) => {
          const sel = el.querySelector('[data-gb-variant]');
          if (sel) this.onVariant(sel, true);
        });
        this.render();
      }

      money(cents) {
        const n = Number(cents) / 100;
        return this.nf ? this.nf.format(n) : this.cfg.currency + ' ' + n.toFixed(2);
      }

      tpl(str, vars) {
        return String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
      }

      itemData(el) {
        const sel = el.querySelector('[data-gb-variant]');
        if (sel && sel.selectedOptions[0]) {
          const o = sel.selectedOptions[0];
          return { id: o.value, price: Number(o.dataset.price), variant: o.textContent.split(' - ')[0].trim() };
        }
        return { id: el.dataset.variantId, price: Number(el.dataset.price), variant: '' };
      }

      onVariant(sel, silent) {
        const el = sel.closest('[data-gb-item]');
        const o = sel.selectedOptions[0];
        if (!el || !o) return;
        const priceEl = el.querySelector('[data-gb-item-price]');
        if (priceEl) priceEl.textContent = this.money(o.dataset.price);
        if (!silent) this.render();
      }

      onClick(e) {
        const box = e.target.closest('[data-gb-box]');
        if (box && !box.disabled) {
          this.state.box = box;
          this.say('');
          this.render();
          return;
        }
        const add = e.target.closest('[data-gb-add]');
        if (add && !add.disabled) {
          const el = add.closest('[data-gb-item]');
          const i = this.state.items.indexOf(el);
          if (i > -1) {
            this.state.items.splice(i, 1);
            this.say('');
          } else if (this.state.items.length >= this.cfg.max) {
            this.say(this.cfg.texts.errorMax, 'error');
          } else {
            this.state.items.push(el);
            this.say('');
          }
          this.render();
          return;
        }
        const slot = e.target.closest('[data-gb-slot-index]');
        if (slot) {
          this.state.items.splice(Number(slot.dataset.gbSlotIndex), 1);
          this.render();
          return;
        }
        if (e.target.closest('[data-gb-submit]')) this.submit();
      }

      say(text, type) {
        if (!this.feedbackEl) return;
        this.feedbackEl.textContent = text || '';
        this.feedbackEl.className = 'gb__msg' + (type ? ' is-' + (type === 'error' ? 'error' : 'ok') : '');
      }

      currentTier() {
        const n = this.state.items.length;
        let cur = null;
        this.tiers.forEach((t) => { if (n >= t.items) cur = t; });
        return cur;
      }

      render() {
        const { box, items } = this.state;
        const cfg = this.cfg;

        this.boxEls.forEach((b) => {
          const on = b === box;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        this.itemEls.forEach((el) => {
          const on = items.includes(el);
          el.classList.toggle('is-selected', on);
          const btn = el.querySelector('[data-gb-add]');
          if (btn) {
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            btn.setAttribute('aria-label', (on ? cfg.texts.remove : cfg.texts.add) + ' ' + el.dataset.title);
          }
        });

        if (this.previewImg) {
          const src = box && box.dataset.preview;
          if (src) {
            if (this.previewImg.getAttribute('src') !== src) this.previewImg.src = src;
            this.previewImg.alt = box.dataset.title;
            this.previewImg.hidden = false;
            if (this.previewPh) this.previewPh.hidden = true;
          } else {
            this.previewImg.hidden = true;
            if (this.previewPh) this.previewPh.hidden = false;
          }
          if (this.previewName) this.previewName.textContent = box ? box.dataset.title : '';
        }

        if (this.slotsEl) {
          this.slotsEl.textContent = '';
          for (let i = 0; i < cfg.max; i++) {
            const el = items[i];
            if (el) {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'gb-slot is-filled';
              b.dataset.gbSlotIndex = i;
              b.setAttribute('aria-label', cfg.texts.remove + ' ' + el.dataset.title);
              if (el.dataset.thumb) {
                const img = document.createElement('img');
                img.src = el.dataset.thumb;
                img.alt = '';
                b.appendChild(img);
              } else {
                b.textContent = el.dataset.title.charAt(0);
              }
              this.slotsEl.appendChild(b);
            } else {
              const d = document.createElement('div');
              d.className = 'gb-slot';
              this.slotsEl.appendChild(d);
            }
          }
        }

                this.box_price = box ? Number(box.dataset.price) : 0;
        const prices = items.map((el) => this.itemData(el).price);
        const subtotal = this.box_price + prices.reduce((a, b) => a + b, 0);

        // BOGO (display only, the store's automatic discount applies it in cart).
        // In every full group of (buy + get), the cheapest "get" items are discounted.
        let bogoSave = 0;
        const bg = cfg.bogo;
        if (bg && bg.enabled) {
          const pool = prices.slice();
          if (bg.includeBox && box) pool.push(this.box_price);
          pool.sort((a, b) => b - a);
          const size = bg.buy + bg.get;
          for (let i = 0; i + size <= pool.length; i += size) {
            pool.slice(i + bg.buy, i + size).forEach((p) => {
              bogoSave += Math.round(p * bg.percent / 100);
            });
          }
        }

        const tier = this.currentTier();
        const pct = tier ? tier.percent : 0;
        const total = Math.round((subtotal - bogoSave) * (100 - pct) / 100);
        const saved = subtotal - total;
        const need = Math.max(cfg.min - items.length, 0);
        const ready = !cfg.hideTotalUntilMin || (need === 0 && !!box);

        if (this.totalEl) {
          this.totalEl.classList.toggle('is-pending', !ready);
          this.totalEl.textContent = ready
            ? this.money('2499')
            : (need ? this.tpl(cfg.texts.totalPending, { count: need }) : cfg.texts.errorBox);
        }
        if (this.wasEl) {
          const showWas = ready && saved > 0;
          this.wasEl.hidden = !showWas;
          this.wasEl.textContent = showWas ? this.money(subtotal) : '';
        }
        if (this.noteEl) this.noteEl.hidden = !(ready && pct);
        if (this.bogoEl) {
          const showBogo = ready && bogoSave > 0;
          this.bogoEl.hidden = !showBogo;
          this.bogoEl.textContent = showBogo ? cfg.texts.bogo + ': -' + this.money(bogoSave) : '';
        }

        if (this.discountEl && this.tiers.length) {
          const n = items.length;
          const next = this.tiers.find((t) => t.items > n);
          if (next) {
            this.progressText.textContent = this.tpl(cfg.texts.progress, { count: next.items - n, percent: next.percent });
          } else {
            this.progressText.textContent = this.tpl(cfg.texts.unlocked, { percent: pct });
          }
          this.tagEl.textContent = pct && next ? this.tpl(cfg.texts.unlocked, { percent: pct }) : '';
          const top = this.tiers[this.tiers.length - 1].items;
          this.barEl.style.width = Math.min(100, Math.round((n / top) * 100)) + '%';
        } else if (this.discountEl) {
          this.discountEl.hidden = true;
        }
      }

      async refreshCart(open) {
        let cart = null;
        try {
          const r = await fetch(this.cfg.cartJsUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          cart = await r.json();
        } catch (e) {}
        const detail = { cart: cart, open: open, openMiniCart: open, openCart: open, source: 'gift-box-builder' };
        document.dispatchEvent(new CustomEvent(this.cfg.cartEvent, { bubbles: true, detail: detail }));
      }

      async submit() {
        if (this.busy) return;
        const cfg = this.cfg;
        const { box, items } = this.state;
        this.say('');

        if (!box) return this.say(cfg.texts.errorBox, 'error');
        if (items.length < cfg.min) return this.say(this.tpl(cfg.texts.errorMin, { min: cfg.min }), 'error');

        this.busy = true;
        this.submitBtn.disabled = true;
        if (this.submitLabel) this.submitLabel.textContent = cfg.texts.adding;

        const setId = 'GB-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();

        const boxProps = { _gift_set_id: setId };
        const message = this.msgEl ? this.msgEl.value.trim() : '';
        if (cfg.messageEnabled && message) boxProps['Gift message'] = message;
        if (this.receiptEl && this.receiptEl.checked) boxProps['Hide prices (gift receipt)'] = 'Yes';

        const lines = [{ id: Number(box.dataset.variantId), quantity: 1, properties: boxProps }];
        items.forEach((el) => {
          const d = this.itemData(el);
          lines.push({
            id: Number(d.id),
            quantity: 1,
            properties: { _gift_set_id: setId, 'Packed in': box.dataset.title }
          });
        });

        try {
          const res = await fetch(cfg.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines })
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || cfg.texts.errorGeneric);

          const tier = this.currentTier();
          if (tier && tier.code) {
            try { await fetch(cfg.discountUrl + encodeURIComponent(tier.code), { credentials: 'same-origin' }); } catch (e) {}
          }

          document.dispatchEvent(new CustomEvent('gift-box:added', { bubbles: true, detail: { setId: setId, response: data } }));

          if (cfg.afterAdd === 'redirect') {
            window.location.href = cfg.cartUrl;
            return;
          }

          await this.refreshCart(cfg.afterAdd === 'drawer');

          this.say(cfg.texts.success, 'ok');
          this.state.items = [];
          if (this.msgEl) {
            this.msgEl.value = '';
            if (this.countEl) this.countEl.textContent = '0/' + this.msgEl.maxLength;
          }
          if (this.receiptEl) this.receiptEl.checked = false;
          this.render();
        } catch (err) {
          this.say(err.message || cfg.texts.errorGeneric, 'error');
        } finally {
          this.busy = false;
          this.submitBtn.disabled = false;
          if (this.submitLabel) this.submitLabel.textContent = this.defaultLabel;
        }
      }
    }
    customElements.define('gift-box-builder', GiftBoxBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giftbox"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-box-builder')) {
    class GiftBoxBuilder extends HTMLElement {

      /* ---------- Lifecycle ---------- */
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this._ready) return;
        const cfgEl = this.querySelector('[data-gb-config]');
        if (!cfgEl) return;
        this._ready = true;

        this.cfg = JSON.parse(cfgEl.textContent);

        // Elements
        this.itemEls = [...this.querySelectorAll('[data-gb-item]')];
        this.thumbEls = [...this.querySelectorAll('[data-gb-thumb]')];
        this.mainImg = this.querySelector('[data-gb-main]');
        this.msgEl = this.querySelector('[data-gb-message]');
        this.countEl = this.querySelector('[data-gb-count]');
        this.receiptEl = this.querySelector('[data-gb-receipt]');
        this.feedbackEl = this.querySelector('[data-gb-feedback]');
        this.submitBtn = this.querySelector('[data-gb-submit]');
        this.submitLabel = this.querySelector('[data-gb-submit-label]');
        this.defaultLabel = this.submitLabel ? this.submitLabel.textContent : '';

        // Remembered so clicking an active thumbnail again returns to the main image
        this.mainSrc = this.mainImg ? (this.mainImg.getAttribute('src') || '') : '';

        // Events
        this.addEventListener('click', (e) => this.onClick(e));
        if (this.msgEl) {
          this.msgEl.addEventListener('input', () => {
            if (this.countEl) this.countEl.textContent = this.msgEl.value.length + '/' + this.msgEl.maxLength;
          });
        }
      }

      onClick(e) {
        if (e.target.closest('[data-gb-submit]')) return this.submit();
        const thumb = e.target.closest('[data-gb-thumb]');
        if (thumb) this.toggleThumb(thumb);
      }

      /* ---------- Gallery (manual only, no auto change) ---------- */
      setMain(src) {
        if (!this.mainImg || !src || this.mainImg.getAttribute('src') === src) return;
        this.mainImg.hidden = false;
        this.mainImg.classList.remove('is-in');
        void this.mainImg.offsetWidth; // restart animation
        this.mainImg.src = src;
        this.mainImg.classList.add('is-in');
      }

      toggleThumb(thumb) {
        const wasActive = thumb.classList.contains('is-active');
        this.thumbEls.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        if (wasActive) {
          this.setMain(this.mainSrc);
        } else {
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');
          this.setMain(thumb.dataset.src);
        }
      }

      /* ---------- UI helpers ---------- */
      say(text, type) {
        if (!this.feedbackEl) return;
        this.feedbackEl.textContent = text || '';
        this.feedbackEl.className = 'gb__msg' + (type ? ' is-' + (type === 'error' ? 'error' : 'ok') : '');
      }

      setBusy(isBusy) {
        this.busy = isBusy;
        this.submitBtn.disabled = isBusy;
        if (this.submitLabel) {
          this.submitLabel.textContent = isBusy ? this.cfg.texts.adding : this.defaultLabel;
        }
      }

      /* ---------- Cart data ---------- */
      itemVariantId(el) {
        const sel = el.querySelector('[data-gb-variant]');
        return sel ? sel.value : el.dataset.variantId;
      }

      // Builds the line item properties: set id, message, receipt, 4 items + variants
      buildProperties(setId) {
        const props = { _gift_set_id: setId };

        const message = this.msgEl ? this.msgEl.value.trim() : '';
        if (this.cfg.messageEnabled && message) props['Gift message'] = message;
        if (this.receiptEl && this.receiptEl.checked) props['Hide prices (gift receipt)'] = 'Yes';

        const itemIds = [];
        const used = {};
        this.itemEls.forEach((el) => {
          const sel = el.querySelector('[data-gb-variant]');
          let variant = 'Included';
          if (sel && sel.selectedOptions[0]) {
            variant = sel.selectedOptions[0].textContent.split(' - ')[0].trim();
          }

          // Same product twice -> "Name (2)"
          let key = el.dataset.title;
          used[key] = (used[key] || 0) + 1;
          if (used[key] > 1) key += ' (' + used[key] + ')';

          props[key] = variant;
          itemIds.push(this.itemVariantId(el));
        });
        props['_item_variant_ids'] = itemIds.join(',');

        return props;
      }

      /* ---------- Submit ---------- */
      async submit() {
        if (this.busy) return;
        const cfg = this.cfg;
        this.say('');

        if (!cfg.bundleVariantId || !cfg.bundleAvailable) return this.say(cfg.texts.errorBundle, 'error');
        if (this.itemEls.some((el) => el.dataset.soldout === 'true')) return this.say(cfg.texts.errorSoldOut, 'error');

        this.setBusy(true);

        const setId = 'GB-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();

        // ONE single cart line (fixed price). Selected items are stored as properties.
        const lines = [{
          id: Number(cfg.bundleVariantId),
          quantity: 1,
          properties: this.buildProperties(setId)
        }];

        try {
          const res = await fetch(cfg.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines })
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || cfg.texts.errorGeneric);

          document.dispatchEvent(new CustomEvent('gift-box:added', { bubbles: true, detail: { setId: setId, response: data } }));

          // Always go to the cart page after a successful add
          window.location.href = cfg.cartUrl || '/cart';
        } catch (err) {
          this.say(err.message || cfg.texts.errorGeneric, 'error');
          this.setBusy(false);
        }
      }
    }
    customElements.define('gift-box-builder', GiftBoxBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
